import React, { useState, useEffect } from "react";
import Header from "../common/Header/Header";
import Sidebar from "../common/Sidebar/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { MdHome, MdChevronRight } from "react-icons/md";
import "./DashboardPage.css";

const Dashboard = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) setIsCollapsed(true);
  }, [isMobile]);

  // Close the mobile drawer whenever the route changes
  useEffect(() => {
    setIsMobileNavOpen(false);
  }, [location.pathname]);

  const formatText = (text) => {
    return text.replace(/([a-z])([A-Z])/g, "$1 $2");
  };

  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split("/").filter((x) => x);
    const breadcrumbItems = pathnames.map((value, index) => {
      const to = `/${pathnames.slice(0, index + 1).join("/")}`;
      const isLast = index === pathnames.length - 1;
      return (
        <React.Fragment key={to}>
          <span
            className={`breadcrumb-item ${isLast ? "active" : ""}`}
            aria-current={isLast ? "page" : undefined}
            style={{ color: "black", display: "flex", alignItems: "center" }}
          >
            {formatText(value)}
          </span>
          {!isLast && <MdChevronRight style={{ margin: "0 5px" }} />}
        </React.Fragment>
      );
    });
    return (
      <nav aria-label="breadcrumb" style={{ fontSize: "12px", fontWeight: "600" }}>
        <ol
          className="breadcrumb"
          style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexWrap: "wrap", alignItems: "center" }}
        >
          <li
            className="breadcrumb-item"
            style={{ color: "black", textDecoration: "none", display: "flex", alignItems: "center" }}
          >
            <MdHome style={{ fontSize: "14px", marginRight: "3px" }} /> Home
          </li>
          {pathnames.length > 0 && <MdChevronRight style={{ margin: "0 5px" }} />}
          {breadcrumbItems}
        </ol>
      </nav>
    );
  };

  const getTitle = () => {
    const pathnames = location.pathname.split("/").filter((x) => x);
    const lastPathname = pathnames[pathnames.length - 1];
    if (!lastPathname) return "";
    return lastPathname.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());
  };

  return (
    <div className="maindashboard" style={{ backgroundColor: "white" }}>
      <div className="headerdashboard" style={{ position: "fixed", top: 0, width: "100%", zIndex: 1005 }}>
        <Header onToggleSidebar={() => setIsMobileNavOpen((open) => !open)} />
      </div>
      <div className="d-flex" style={{ marginTop: "75px" }}>
        <div
          className={`sidebardashboard${isMobileNavOpen ? " mobile-open" : ""}`}
          style={{
            width: isCollapsed ? "80px" : "280px",
            height: "100%",
            position: "fixed",
            boxShadow: "2px 0 4px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
            overflowY: "hidden",
            transition: "width 0.3s",
            zIndex: 1001
          }}
          onMouseEnter={() => !isMobile && setIsCollapsed(false)}
          onMouseLeave={() => !isMobile && setIsCollapsed(true)}
        >
          <Sidebar
            isCollapsed={isMobile ? false : isCollapsed}
            isMobileOpen={isMobileNavOpen}
            onNavigate={() => setIsMobileNavOpen(false)}
          />
        </div>
        <div
          className={`sidebar-overlay${isMobileNavOpen ? " active" : ""}`}
          onClick={() => setIsMobileNavOpen(false)}
        />
        <div
          className="flex-grow-1 dashboard-main-content"
          style={{
            marginLeft: "80px",
            overflowY: "auto",
            transition: "none",
            scrollbarWidth: "thin",
            scrollbarColor: "black",
          }}
        >
          {/* <div
            className="d-flex justify-content-between align-items-center breadcrumb-main"
            style={{
              padding: "7px 20px",
              background: "#fff",
              width: "100%",
              marginTop: "2px",
              marginBottom: "-12px",
            }}
          >
            <h3 className="dynamictitle" style={{ fontWeight: "500", fontSize: "20px", color: "#333", padding: "2px" }}>
              {getTitle()}
            </h3>
            {location.pathname !== "/" && <div className="breadcrumb">{generateBreadcrumbs()}</div>}  
          </div> */}

          {!['/', '/LoginPage', '/SignupPage'].includes(location.pathname) && (
            <div
              className="d-flex justify-content-between align-items-center breadcrumb-main"
              style={{
                padding: '12px 20px',
                background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                width: "100%",
                marginTop: 0,
                marginBottom: 0,
                display: "flex",
                alignItems: "center",
                borderBottom: "2px solid #e9ecef",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                gap: "20px"
              }}
            >
              <h3 
                className="dynamictitle" 
                style={{ 
                  fontWeight: "600", 
                  fontSize: "22px", 
                  color: "#1a1a1a", 
                  padding: "0", 
                  margin: 0,
                  letterSpacing: "-0.5px"
                }}
              >
                {getTitle()}
              </h3>
              <div 
                className="breadcrumb" 
                style={{ 
                  margin: 0, 
                  padding: "4px 12px",
                  marginLeft: "auto",
                  backgroundColor: "#f0f2f5",
                  borderRadius: "6px",
                  fontSize: "13px"
                }}
              >
                {generateBreadcrumbs()}
              </div>
            </div>
          )}

          <div className="outlet" style={{ padding: "10px", backgroundColor: "#f2f3f4" }}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;